export function ContactInfoBar() {
  return (
    <div className="bg-orange-400 text-white py-4">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row items-center justify-center text-center">
          {/* Main Office */}
          <div className="flex-1">
            <div className="text-sm font-semibold mb-1 text-blue-800">
              MAIN OFFICE
            </div>
            <div className="text-2xl font-bold">
              <a 
                href="tel:8592551902"
                className="hover:text-gray-200 transition-colors"
              >
                859.255.1902
              </a>
            </div>
          </div>

          {/* Vertical Separator */}
          <div className="hidden md:block w-px h-16 bg-black mx-8"></div>

          {/* AOG 24-HR On-Call */}
          <div className="flex-1 mt-4 md:mt-0">
            <div className="text-sm font-semibold mb-1 text-blue-800">
              AOG 24-HR ON-CALL
            </div>
            <div className="text-2xl font-bold">
              <a 
                href="tel:8592551902"
                className="hover:text-gray-200 transition-colors"
              >
                859.255.1902
              </a>
            </div>
          </div>

          {/* Vertical Separator */}
          <div className="hidden md:block w-px h-16 bg-black mx-8"></div>

          {/* Regular Hours */}
          <div className="flex-1 mt-4 md:mt-0">
            <div className="text-sm font-semibold mb-1 text-blue-800">
              REGULAR HOURS
            </div>
            <div className="text-2xl font-bold">
              8:00am – 4:30pm
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}